export default "__VITE_ASSET__CznEwXmL__"